import React from "react";
import { StatCardProps } from "./types";
import * as MUIcon from "@mui/icons-material";
import {
  Card,
  Category,
  Content,
  ContentWrapper,
  IconWrapper,
  MainWrapper,
} from "./styles";

function convertTime(minutes: number): string {
  if (minutes < 0) {
    throw new Error("El número de minutos no puede ser negativo.");
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.floor(minutes % 60); // Redondear los minutos hacia abajo

  const hoursText = hours > 0 ? `${hours} h` : "";
  const minutesText = remainingMinutes > 0 ? `${remainingMinutes} min` : "";

  if (hoursText && minutesText) {
    return `${hoursText} ${minutesText}`;
  } else if (hoursText) {
    return hoursText;
  } else {
    return minutesText;
  }
}

const StatCard: React.FC<StatCardProps> = ({
  icon = "MeetingRoom",
  category = "Última sala reservada",
  content = "Sala de Seguridad",
  color,
  time = false,
}) => {
  const Icon =
    icon && (MUIcon[icon as keyof typeof MUIcon] as React.ElementType);

  return (
    <Card>
      <MainWrapper>
        <IconWrapper>
          {Icon && (
            <Icon
              sx={{
                fontSize:
                  window.innerWidth <= 400
                    ? "50px"
                    : window.innerWidth > 1000 && window.innerWidth <= 1300
                    ? "60px"
                    : "80px",
                color: color || "black",
              }}
            />
          )}
        </IconWrapper>
        <ContentWrapper>
          <Category>{category}</Category>
          <Content>
            {time
              ? // Aplicar estilo a "h" y "min" si "time" es verdadero
                convertTime(content as unknown as number)
                  .split(" ")
                  .map((segment, index) => (
                    <span
                      key={index}
                      style={{
                        fontSize:
                          segment === "h" ||
                          segment === "min" ||
                          segment === " "
                            ? "1.3rem"
                            : "2rem",
                        fontWeight:
                          segment === "h" || segment === "min" ? "600" : "700",
                        opacity: segment === "h" || segment === "min" ? 0.5 : 1,
                        marginRight: segment === "h" ? "0.5rem" : "0",
                      }}
                    >
                      {segment}
                    </span>
                  ))
              : // Si "time" es falso, mostrar el contenido normalmente
                content}
          </Content>
        </ContentWrapper>
      </MainWrapper>
    </Card>
  );
};

export default StatCard;
